import '.is{display:inline-block;}.ssr-plugin'
import '.it{margin-top:1.5rem;}.ssr-plugin'
import '.ah{font-size:0.875rem;}.ssr-plugin'
import '.iu{color:var(--palette-blue-500);}.ssr-plugin'
import '.hg{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="is it ah iu hg"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
